import React from 'react';

import { injectIntl, InjectedIntl } from 'react-intl';

import DetailViewIcon from '@atlaskit/icon/glyph/detail-view';
import { FileIdentifier } from '@atlaskit/media-client';
import { MediaClientConfig } from '@atlaskit/media-core';
import { MediaViewer } from '@atlaskit/media-viewer';

import { MetadataPanel } from 'src/components/metadata-panel';
import { useDjangoFeature } from 'src/hooks/use-django-feature';

import messages from './i18n';
import { Attachment, CollectionName } from './types';

interface MVActions {
  close?: () => void;
}

interface Props {
  mediaClientConfig: MediaClientConfig;
  identifier: FileIdentifier;
  intl: InjectedIntl;
  collectionName: CollectionName;
  onClose: () => void;
  dataSource: { list: FileIdentifier[] };
  getAttachmentData: (id: FileIdentifier) => Attachment | undefined;
}

function MediaViewerWithMetadataPanel(props: Props) {
  const sidebarEnabled = useDjangoFeature(
    'pr-attachments-media-viewer-sidebar'
  );
  const sidebarRenderer = (identifier: FileIdentifier, actions: MVActions) => {
    const attachment = props.getAttachmentData(identifier);
    const { intl } = props;

    return (
      <MetadataPanel
        title={intl.formatMessage(messages.metadataPanelHeading)}
        description={attachment?.description}
        metadata={attachment?.metadata || []}
        close={actions && actions.close}
        isLoading={false}
        uploadedBy={attachment?.uploaded_by}
        uploadedDate={attachment?.created_on}
      />
    );
  };

  return (
    <MediaViewer
      mediaClientConfig={props.mediaClientConfig}
      selectedItem={props.identifier}
      items={props.dataSource.list}
      collectionName={props.collectionName}
      onClose={props.onClose}
      extensions={
        sidebarEnabled
          ? {
              sidebar: {
                renderer: sidebarRenderer,
                icon: (
                  <DetailViewIcon
                    label={props.intl.formatMessage(
                      messages.metadataPanelToggleActionLabel
                    )}
                  />
                ),
              },
            }
          : undefined
      }
    />
  );
}

export default injectIntl(MediaViewerWithMetadataPanel);
